export default __webpack_public_path__ + "static/media/24.9f5cb658.png";